import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  Tooltip,
  Checkbox,
} from '@material-ui/core';

class EnhancedTableHead extends React.Component {
  static propTypes = {
    headers: PropTypes.array,
    numSelected: PropTypes.number,
    onRequestSort: PropTypes.func,
    onSelectAllClick: PropTypes.func,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  static defaultProps = {
    headers: [],
    numSelected: 0,
    onRequestSort: () => {},
    onSelectAllClick: () => {},
  };

  createSortHandler = property => (event) => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const {
      headers, numSelected, rowCount, onSelectAllClick, order, orderBy,
    } = this.props;

    return (
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={numSelected === rowCount}
              onChange={onSelectAllClick}
            />
          </TableCell>
          {headers.map(header => (
            <TableCell
              key={header.value}
              numeric={header.numeric}
              padding={header.disablePadding ? 'none' : 'default'}
              sortDirection={orderBy === header.value ? order : false}
            >
              <Tooltip
                title="Sort"
                placement={header.numeric ? 'bottom-end' : 'bottom-start'}
                enterDelay={300}
              >
                <TableSortLabel
                  active={orderBy === header.value}
                  direction={order}
                  onClick={this.createSortHandler(header.value)}
                >
                  <Label>{header.label}</Label>
                </TableSortLabel>
              </Tooltip>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }
}

export default EnhancedTableHead;

const Label = styled.div`
  min-width: 80px;
`;



// WEBPACK FOOTER //
// ./src/components/DataTable/components/EnhanchedTableHead.js